/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon-phone': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.688 12.686l-3.32-3.32a1.068 1.068 0 00-1.509 0l-.754.755c-.427.427-1.81.002-3.019-1.208-1.209-1.209-1.634-2.59-1.207-3.018l.755-.754a1.068 1.068 0 000-1.51L3.314.313a1.068 1.068 0 00-1.51 0l-.754.755c-.557.557-.897 1.29-1.01 2.18-.104.824-.007 1.748.286 2.747.59 2.006 1.92 4.115 3.742 5.938 1.824 1.822 3.932 3.152 5.938 3.741.738.218 1.436.327 2.083.327.222 0 .444-.013.665-.04.889-.113 1.622-.453 2.18-1.01l.754-.755a1.068 1.068 0 000-1.509z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
